import { render, staticRenderFns } from "./d2-demo-mock-card.vue?vue&type=template&id=1b031a6c&scoped=true&"
import script from "./d2-demo-mock-card.vue?vue&type=script&lang=js&"
export * from "./d2-demo-mock-card.vue?vue&type=script&lang=js&"
import style0 from "./d2-demo-mock-card.vue?vue&type=style&index=0&id=1b031a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b031a6c",
  null
  
)

component.options.__file = "d2-demo-mock-card.vue"
export default component.exports